import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import AboutPage from '@/pages/about/page';
import AcademyPage from '@/pages/academy/page';
import CertificationPage from '@/pages/certification/page';
import CommunityPage from '@/pages/community/page';
import AdminPage from '@/pages/admin/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/academy', element: <AcademyPage /> },
  { path: '/certification', element: <CertificationPage /> },
  { path: '/community', element: <CommunityPage /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
